var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"#fff"}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.activeDrawer}}),_c('v-spacer'),_c('p',{staticClass:"ma-0 mr-4"},[_vm._v("Usuário: "+_vm._s(_vm._f("pascalCase")(_vm.userName)))]),_c('p',{staticClass:"ma-0"},[_vm._v("Papel: "+_vm._s(_vm._f("pascalCase")(_vm.role)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }